import { Button } from '@mantine/core';
import { ChevronRight } from 'lucide-react';
import type { FC, ReactNode } from 'react';
import { cn } from '@/utils';
import { STEP_CONTENT_CLASS_NAMES } from '../../classNames';

interface StepperNextButtonProps {
	children: ReactNode;
	disabled?: boolean;
	loading?: boolean;
	onClick: () => void;
	testId: string;
}

const StepperNextButton: FC<StepperNextButtonProps> = ({
	children,
	disabled,
	loading,
	onClick,
	testId
}) => (
	<Button
		className={cn(STEP_CONTENT_CLASS_NAMES.nextButton, {
			'hover:!bg-gray-200': disabled
		})}
		classNames={{
			section: 'ml-0',
			label: 'h-auto leading-normal'
		}}
		data-testid={testId}
		disabled={disabled}
		loading={loading}
		onClick={onClick}
		rightSection={
			<ChevronRight
				aria-hidden="true"
				className="h-4 w-4"
			/>
		}
		type="button"
	>
		{children}
	</Button>
);

export default StepperNextButton;
